import { baseEntitySchema } from '../entity.js'
import { z } from 'zod'
import { coreElementValueSchema } from '../slate/slate-element.js'

export const noteSchema = baseEntitySchema.extend({
  type: z.literal('note'),
  noteType: z.enum(['general', 'performance', 'instrument']).optional(),
  /**
   * Optional element id this note is anchored to within the parent song.
   * When set, the note is rendered with an inline marker on the matching Slate
   * element. When unset (or when the target id no longer resolves), the note
   * remains visible in the entity-level panel without a marker.
   */
  targetElementId: z.string().optional(),
  /** Notes use YDoc for collaborative editing. Children is kept for backwards compatibility. */
  children: coreElementValueSchema.nullable().optional(),
})

export function isNote(node: unknown): node is z.infer<typeof noteSchema> {
  return noteSchema.safeParse(node).success
}

export type Note = z.infer<typeof noteSchema>

export default noteSchema
